import { useCallback, useState } from 'react';
import { Location } from 'history';

import {
  JUMPLINK_PRICEGUIDE,
  JUMPLINK_REVIEWS,
  JUMPLINK_LISTINGS,
  JUMPLINK_PRODUCT_DETAILS,
  IJumplinks,
} from '../components/csp_jumplinks';

interface IUseJumplinksStateArgs {
  queryDataLoading?: boolean;
  hfidPresent?: boolean;
  featuredListingPresent?: boolean;
  fallbackListingsPresent?: boolean;
  location: Location;
  totalNonbumpedListings: number;
  totalBumpedListings: number;
}

interface IUseJumplinksReturnType {
  jumplinks: Partial<IJumplinks>;
  setJumplinks: (newJumplinks: Partial<IJumplinks>) => void;
}

export function useJumplinksState({
  queryDataLoading,
  hfidPresent,
  featuredListingPresent,
  location,
  totalNonbumpedListings,
  totalBumpedListings,
}: IUseJumplinksStateArgs): IUseJumplinksReturnType {
  const [jumplinksState, setJumplinksState] = useState({});

  const setJumplinks = useCallback((newJumplinks) => {
    const jumplinksChanged = Object.keys(newJumplinks).some(key => jumplinksState[key] !== newJumplinks[key]);

    if (jumplinksChanged) {
      setJumplinksState(oldState => ({ ...oldState, ...newJumplinks }));
    }
  }, [jumplinksState]);

  function showListingsJumpLink() {
    if (queryDataLoading || hfidPresent || featuredListingPresent) return true;

    if (!!location?.query?.page && location.query.page > 1) {
      return totalNonbumpedListings > 0;
    }

    return (totalNonbumpedListings + totalBumpedListings) > 0;
  }

  const jumplinks = {
    [JUMPLINK_LISTINGS]: showListingsJumpLink(),
    [JUMPLINK_PRODUCT_DETAILS]: true,
    [JUMPLINK_PRICEGUIDE]: true,
    [JUMPLINK_REVIEWS]: true,
    ...jumplinksState,
  };

  return { jumplinks, setJumplinks };
}
